import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrink: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDrink"><Path d="M17.5 22.5H6.5L5.8125 11.5L5.5 6.5H18.5L18.1875 11.5L17.5 22.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M18.1875 11.5H5.8125" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 6.5V2.5L16 1.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDrink;
